import MuiCollapse from "@mui/material/Collapse";
import type { TransitionProps as MuiTransitionProps } from "@mui/material/transitions/transition";
import React from "react";
interface CollapseProps {
    id?: string;
    /**
     * The content node to be collapsed.
     */
    children?: React.ReactNode;
    /**
     * If `true`, the component will be expanded.
     */
    in?: boolean;
    /**
     * The duration for the transition, in milliseconds.
     *
     * Set to 'auto' to automatically calculate transition time based on height.
     */
    timeout?: number | "auto";
    /**
     * By default the child component stays mounted after it reaches the
     * 'exited' state. Set `unmountOnExit` if you'd prefer to unmount the
     * component after it finishes exiting.
     */
    unmountOnExit?: boolean | undefined;
}
export function Collapse(props: CollapseProps) {
    return <MuiCollapse {...props}>{props.children}</MuiCollapse>;
}
export type TransitionProps = MuiTransitionProps;
